import { createAction, props } from '@ngrx/store';
import { Collection, Filter } from '../../models';

export const LoadCollections = createAction('[Products] Load Collections');
export const LoadCollectionsSuccess = createAction('[Products] Load Collections Success', props<{ collections: any }>());
export const LoadCollectionsFail = createAction('[Products] Load Collections Fail', props<{ error: any }>());

export const LoadCollectionByHandle = createAction('[Products] Load Collections By Handle', props<{ handle: string }>());
export const LoadCollectionByHandleSuccess = createAction(
  '[Products] Load Collections By Handle Success',
  props<{ collection: any; handle: string }>()
);
export const LoadCollectionByHandleFail = createAction('[Products] Load Collections By Handle Fail', props<{ error: any }>());
